module.exports = __webpack_public_path__ + "img/stage_malve.59c531cd.jpg";